var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiberia({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_6828)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.74295 4.36368H21.2571C20.5733 3.53563 19.7801 2.80134 18.9003 2.18188H5.09968C4.21989 2.80124 3.42681 3.53559 2.74295 4.36368Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 12.3678 0.0174844 12.7315 0.049875 13.0909H23.9501C23.9825 12.7315 24 12.3678 24 12C24 11.6322 23.9825 11.2685 23.9501 10.9091H0.049875C0.0174844 11.2685 0 11.6322 0 12H0Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.30856 17.4545H22.6914C23.0448 16.7633 23.333 16.0334 23.5481 15.2728H0.451874C0.666983 16.0334 0.955264 16.7633 1.30856 17.4545Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.09968 21.8182H18.9003C19.7801 21.1988 20.5732 20.4645 21.257 19.6364H2.74295C3.42681 20.4644 4.21989 21.1988 5.09968 21.8182Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.451843 8.72727H23.5482C23.333 7.96658 23.0448 7.23664 22.6915 6.54547H1.30858C0.955281 7.23664 0.667 7.96658 0.451843 8.72727Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.73914 2.1818H18.9003C16.9484 0.807516 14.5686 0 12 0C10.4348 0 7.69101 0.807516 5.73914 2.1818Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4783 6.54547H22.6914C22.2924 5.76487 21.8104 5.03366 21.2571 4.36368H11.4783V6.54547Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4783 10.9091H23.9501C23.8826 10.16 23.747 9.4304 23.5482 8.72733H11.4783V10.9091Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.451866 15.2728H23.5481C23.747 14.5697 23.8826 13.8401 23.9501 13.091H0.0498657C0.117366 13.8401 0.253022 14.5697 0.451866 15.2728Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.74294 19.6363H21.2571C21.8104 18.9662 22.2924 18.2351 22.6914 17.4545H1.30856C1.70761 18.2351 2.18958 18.9663 2.74294 19.6363Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 24C14.5686 24 16.9485 23.1925 18.9003 21.8182H5.09967C7.05155 23.1925 9.43139 24 12 24Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.451819 8.72728C0.252975 9.43041 0.117366 10.1599 0.0498657 10.9091H12V0C6.50718 0 1.87644 3.69056 0.451819 8.72728Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.1432 3.13046L7.92015 5.52179H10.4348L8.40053 6.99985L9.17743 9.39132L7.1432 7.91335L5.10887 9.39132L5.88597 6.99985L3.85168 5.52179H6.3662L7.1432 3.13046Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_6828"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiberia);
export default __webpack_public_path__ + "static/media/liberia.19f145be3a64a8bc176cb93aecd506b9.svg";
export { ForwardRef as ReactComponent };